import { actions } from 'actions';
import { createUniqueStr } from 'helpers';

const initialState = {
  status: createUniqueStr(),
  items: [],
  pagination: null,
  search_attr: 'email',
  search_str: '',
};

/**
 * 管理者アカウント情報を管理する
 */
const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    // 管理者カウントステータス更新
    case actions.TOGGLE_ACCOUNT_ENABLE_DISABLE: {
      const data = state.items.filter(state => state.sub === action.sub);
      data[0].enabled = action.enabled;
      return {
        ...state,
        status: createUniqueStr(),
        items: [
          ...state.items.filter(state => state.sub !== action.sub),
          data[0]
        ]
      }; 
    }
    // 管理者アカウント削除
    case actions.DELETE_ACCOUNT:
      return {
        ...state,
        status: createUniqueStr(),
        items: state.items.filter(state => state.sub !== action.sub)
      };
    // 管理者アカウント取得
    case actions.FETCH_ACCOUNT:
      return {
        ...state,
        status: createUniqueStr(),
        items: [
          ...state.items.filter(state => state.sub !== action.sub),
          action.item
        ]
      };
    // 管理者アカウント一覧取得
    case actions.FETCH_ACCOUNTS: {
      if (action.load_more) {
        return {
          status: createUniqueStr(),
          search_attr: action.search_attr,
          search_str: action.search_str,
          pagination: action.pagination,     
          items: state.items.concat(action.items)
        };
      } else {
        return {
          status: createUniqueStr(),
          search_attr: action.search_attr,
          search_str: action.search_str,
          pagination: action.pagination,     
          items: action.items
        };    
      }
    }
    // 管理者カウント登録・更新
    case actions.REGIST_ACCOUNT:
    case actions.UPDATE_ACCOUNT:
    default:
      return state;
  }
};

export default accountReducer;